// extracted by mini-css-extract-plugin
export default {"form":"AMLGreenIDCheck_form__yfmrd","image":"AMLGreenIDCheck_image__IMrT8"};